import { colors } from '@/theme/colors';
import { FilterPrimitive } from '../types/filters';

type InventoryFilterColors = {
  [color: string]: string;
};

// Map of vehicle colors to color swatches
const INVENTORY_FILTER_COLORS: InventoryFilterColors = {
  Black: colors.neutral1,
  Blue: colors.blue50,
  Brown: colors.swatchBrown,
  Gold: colors.swatchGold,
  Green: colors.swatchGreen,
  // To be safe, we account for both spellings of gray
  Gray: colors.neutral70,
  Grey: colors.neutral70,
  Orange: colors.swatchOrange,
  Red: colors.swatchRed,
  Silver: colors.neutral80,
  White: colors.neutral100,
};

/**
 * Check if a given color is a valid vehicle color we display in the inventory filters with a color swatch.
 *
 * @param color Exterior or interior color of vehicle
 * @returns Boolean indicating if given color is a vehicle color we have a color swatch for
 */
function isInventoryFilterColor(color: FilterPrimitive) {
  if (typeof color !== 'string') return false;

  return Object.keys(INVENTORY_FILTER_COLORS).includes(color);
}

/**
 * Check if a given color is not a valid vehicle color we display in the inventory filters with a color swatch.
 * This is the inverse of isInventoryFilterColor.
 *
 * @param color Exterior or interior color of vehicle
 * @returns Boolean indicating if given color is not a vehicle color we have a color swatch for
 */
function isNotInventoryFilterColor(color: FilterPrimitive) {
  return !isInventoryFilterColor(color);
}

export { INVENTORY_FILTER_COLORS, isInventoryFilterColor, isNotInventoryFilterColor };
